import { getIsCheckoutStep } from '~/features/checkout/utils/getIsCheckoutStep';

const FRAGMENT_IDENTIFIER_REGEX = /#(\w*)/;

export const getCheckoutStepFromUrl = (path: string) => {
	const hash = path.match(FRAGMENT_IDENTIFIER_REGEX)?.[1];
	return getIsCheckoutStep(hash) ? hash : undefined;
};
